import React from 'react'

import { InputAttrs } from '../../../../util/useForm/useForm'
import SingleLineInput from '../../../atoms/SingleLineInput/SingleLineInput'
import FormInput from '../../../molecules/FormInput/FormInput'
import RadioButton from '../../../atoms/RadioButton/RadioButton'

import * as Styled from './PaymentForm.styles'
import { InvoiceAddressChoice, PaymentMethod } from './PaymentForm.types'
import RadioGroup from '../../../molecules/RadioGroup/RadioGroup'
import Heading from '../../../atoms/Heading/Heading'
import SingleSelectDropDownMenu from '../../../atoms/SingleSelectDropDownMenu/SingleSelectDropDownMenu'
import CountryList from '../../../../components/shared/country-list/CountryList'
import { useAppSelector } from '../../../../state/reducers/types'

export type PaymentFormProps = {
  referenceNumber: InputAttrs<string>
  paymentMethod: InputAttrs<PaymentMethod>
  paymentParams: InputAttrs<string>
  invoiceAddressChoice: InputAttrs<InvoiceAddressChoice>
  companyName: InputAttrs<string>
  address: InputAttrs<string>
  postalCode: InputAttrs<string>
  city: InputAttrs<string>
  country: InputAttrs<string>
  className?: string
}

const shouldDisplayOpRekening = (isUserVerified: boolean): boolean => isUserVerified

const PaymentForm: React.FunctionComponent<PaymentFormProps> = ({
  invoiceAddressChoice,
  referenceNumber,
  paymentMethod,
  address,
  city,
  country,
  companyName,
  postalCode,
  className,
}) => {
  const isVerifiedUser = useAppSelector(state => state.user.isVerified)
  const displayOpRekening = shouldDisplayOpRekening(isVerifiedUser)

  return (
    <Styled.Wrapper className={className}>
      <FormInput
        inputId="reference-input"
        title="Referentienummer t.b.v. facturatie"
        validationMessage={referenceNumber.validationMessage}
      >
        <SingleLineInput
          id="reference-input"
          onChange={referenceNumber.onChange}
          value={referenceNumber.value}
          isValid={referenceNumber.isValid}
          placeholder="Referentienummer"
          autoComplete="off"
        />
      </FormInput>
      <Styled.Divider />
      <Styled.Fieldset>
        {displayOpRekening && (
          <div>
            <RadioButton
              label="Op rekening"
              name="invoice"
              checked={paymentMethod.value === PaymentMethod.Invoice}
              id="invoice-radio"
              onChange={() => {
                paymentMethod.onChange(PaymentMethod.Invoice)
              }}
            />
            <Styled.RadioButtonDetail>
              <Styled.RadioButtonInfo>Factuurtermijn 30 dagen</Styled.RadioButtonInfo>
            </Styled.RadioButtonDetail>
          </div>
        )}
        <RadioButton
          label="iDEAL | Wero"
          name="ideal"
          checked={paymentMethod.value === PaymentMethod.iDeal}
          id="ideal-radio"
          onChange={() => {
            paymentMethod.onChange(PaymentMethod.iDeal)
          }}
        />
        <RadioButton
          label="Mastercard"
          name="mastercard"
          checked={paymentMethod.value === PaymentMethod.Mastercard}
          id="mastercard-radio"
          onChange={() => {
            paymentMethod.onChange(PaymentMethod.Mastercard)
          }}
        />
        <RadioButton
          label="Visa"
          name="visa"
          checked={paymentMethod.value === PaymentMethod.Visa}
          id="visa-radio"
          onChange={() => {
            paymentMethod.onChange(PaymentMethod.Visa)
          }}
        />
      </Styled.Fieldset>
      <Styled.Divider />
      <Heading>Facturatie adres</Heading>
      <RadioGroup
        {...invoiceAddressChoice}
        options={[InvoiceAddressChoice.UseExistingAddress, InvoiceAddressChoice.UseOtherAddress]}
      />
      {invoiceAddressChoice.value === InvoiceAddressChoice.UseOtherAddress && (
        <Styled.AddressInputContainer>
          <FormInput
            inputId="company-name-input"
            title="Vul een bedrijfsnaam in"
            isValid={companyName.isValid}
            validationMessage={companyName.validationMessage}
          >
            <SingleLineInput
              id="company-name-input"
              onChange={companyName.onChange}
              value={companyName.value}
              isValid={companyName.isValid}
              placeholder="Bedrijfsnaam"
              autoComplete="off"
            />
          </FormInput>
          <FormInput
            inputId="address-input"
            title="Adres"
            isValid={address.isValid}
            validationMessage={address.validationMessage}
          >
            <SingleLineInput
              id="address-input"
              onChange={address.onChange}
              value={address.value}
              isValid={address.isValid}
              placeholder="Straat en huisnummer"
              autoComplete="off"
            />
          </FormInput>
          <Styled.Row>
            <FormInput
              inputId="zip-code-input"
              title="Postcode"
              isValid={postalCode.isValid}
              validationMessage={postalCode.validationMessage}
            >
              <SingleLineInput
                id="zip-code-input"
                onChange={postalCode.onChange}
                value={postalCode.value}
                isValid={postalCode.isValid}
                placeholder="1234AB"
                autoComplete="off"
              />
            </FormInput>
            <FormInput
              inputId="city-input"
              title="Plaatsnaam"
              isValid={city.isValid}
              validationMessage={city.validationMessage}
            >
              <SingleLineInput
                id="city-input"
                onChange={city.onChange}
                value={city.value}
                isValid={city.isValid}
                placeholder="Plaats"
                autoComplete="off"
              />
            </FormInput>
          </Styled.Row>
          <FormInput
            inputId="country-input"
            title="Kies een land"
            isValid={country.isValid}
            validationMessage={country.validationMessage}
          >
            <SingleSelectDropDownMenu id="country-input" options={CountryList as any} {...country} />
          </FormInput>
        </Styled.AddressInputContainer>
      )}
    </Styled.Wrapper>
  )
}
export default PaymentForm
